import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import React from "react"
import CommentBoard from "containers/MenuFeatures/CommentBoard/commentBoard"

const NewsFeed = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="News Feed" />
        <BreadcrumbTitle
          title="News Feed"
          breadcrumbItems={[
            { title: "Dashboard" },
            {
              title: "News Feed",
            },
          ]}
        />
        <CommentBoard feature={null} fromEvent={false} />
      </div>
    </React.Fragment>
  )
}

export default NewsFeed
